import type { QuickStartData } from 'ontime-types';

export const quickStartDefaults: QuickStartData = {
  project: {
    title: '',
  },
  settings: {
    timeFormat: '24',
    language: 'en',
  },
};
